import "./ArticlePagination.css";

export default function ArticlePagination({
    currentPage = 1,
    lastPage = 1,
    onPageChange,
}) {
    if (lastPage <= 1) {
        return null;
    }

    const pages = buildPages(
        currentPage,
        lastPage
    );

    return (
        <nav
            className="article-pagination"
            aria-label="صفحه‌بندی مقالات"
            dir="rtl"
        >

            {/* Previous */}

            <button
                type="button"
                className="article-pagination__arrow"
                disabled={currentPage === 1}
                onClick={() =>
                    onPageChange(
                        currentPage - 1
                    )
                }
            >
                {/* <span>‹</span> */}
                قبلی
            </button>


            {/* Pages */}

            <div className="article-pagination__pages">

                {pages.map((page, index) => {

                    if (page === "...") {
                        return (
                            <span
                                key={`dots-${index}`}
                                className="article-pagination__dots"
                            >
                                ...
                            </span>
                        );
                    }

                    return (
                        <button
                            key={page}
                            type="button"
                            className={
                                page === currentPage
                                    ? "article-pagination__page article-pagination__page--active"
                                    : "article-pagination__page"
                            }
                            onClick={() =>
                                onPageChange(page)
                            }
                            aria-current={
                                page === currentPage
                                    ? "page"
                                    : undefined
                            }
                        >
                            {page}
                        </button>
                    );
                })}

            </div>


            {/* Next */}

            <button
                type="button"
                className="article-pagination__arrow"
                disabled={
                    currentPage === lastPage
                }
                onClick={() =>
                    onPageChange(
                        currentPage + 1
                    )
                }
            >
                بعدی
                {/* <span>›</span> */}
            </button>

        </nav>
    );
}


/*
|--------------------------------------------------------------------------
| Build smart page numbers
|--------------------------------------------------------------------------
*/

function buildPages(
    currentPage,
    lastPage
) {
    const pages = [];

    /*
    |--------------------------------------------------------------------------
    | Small number of pages
    |--------------------------------------------------------------------------
    */

    if (lastPage <= 7) {

        for (
            let i = 1;
            i <= lastPage;
            i++
        ) {
            pages.push(i);
        }

        return pages;
    }


    /*
    |--------------------------------------------------------------------------
    | Beginning
    |--------------------------------------------------------------------------
    */

    if (currentPage <= 4) {

        return [
            1,
            2,
            3,
            4,
            5,
            "...",
            lastPage,
        ];
    }


    /*
    |--------------------------------------------------------------------------
    | End
    |--------------------------------------------------------------------------
    */

    if (currentPage >= lastPage - 3) {

        return [
            1,
            "...",
            lastPage - 4,
            lastPage - 3,
            lastPage - 2,
            lastPage - 1,
            lastPage,
        ];
    }


    /*
    |--------------------------------------------------------------------------
    | Middle
    |--------------------------------------------------------------------------
    */

    return [
        1,
        "...",
        currentPage - 1,
        currentPage,
        currentPage + 1,
        "...",
        lastPage,
    ];
}